 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"USAElection2020": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AccountOpening":"AccountOpening","BackTopBottom":"BackTopBottom","CallupVideoAppHead":"CallupVideoAppHead","Caption":"Caption","Copyright":"Copyright","HomeFooter":"HomeFooter","Img":"Img","MarkTabs":"MarkTabs","MoreTabs":"MoreTabs","Nav":"Nav","NormalCaption":"NormalCaption","Offline":"Offline","Tip":"Tip","ViewMoreLink":"ViewMoreLink","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic","Atlas":"Atlas","FiveNavPic":"FiveNavPic","FourNavPic":"FourNavPic","MdBanner":"MdBanner","ThreeNavPic":"ThreeNavPic","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg":"vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg","vendors~BigImg~BigTopic~InformationFlow~TitleImg~TwoImg":"vendors~BigImg~BigTopic~InformationFlow~TitleImg~TwoImg","vendors~BigTopic~InformationFlow~TitleImg":"vendors~BigTopic~InformationFlow~TitleImg","vendors~BigTopic~InformationFlow~SingleTitle":"vendors~BigTopic~InformationFlow~SingleTitle","vendors~BigImg~InformationFlow":"vendors~BigImg~InformationFlow","vendors~InformationFlow~SlideImg":"vendors~InformationFlow~SlideImg","vendors~BigTopic~InformationFlow":"vendors~BigTopic~InformationFlow","vendors~InformationFlow~TwoImg":"vendors~InformationFlow~TwoImg","vendors~InformationFlow":"vendors~InformationFlow","vendors~BigImage~NewsStream~NoImage~OneImage~Stick~ThreeImage~TwoImage":"vendors~BigImage~NewsStream~NoImage~OneImage~Stick~ThreeImage~TwoImage","Stick":"Stick","TwoImage":"TwoImage","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage","NoImage":"NoImage","vendors~BigImage~NewsStream":"vendors~BigImage~NewsStream","BigImage":"BigImage","vendors~NewsStream~OneImage":"vendors~NewsStream~OneImage","OneImage":"OneImage","vendors~NewsStream~ThreeImage":"vendors~NewsStream~ThreeImage","vendors~NewsStream":"vendors~NewsStream","SingleTitle":"SingleTitle","SlideImg":"SlideImg","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides","vendors~BottomSlides~UpgradeBottomSlides":"vendors~BottomSlides~UpgradeBottomSlides","vendors~UpgradeBottomSlides":"vendors~UpgradeBottomSlides","vendors~IndexSlides":"vendors~IndexSlides","vendors~NormalSlides":"vendors~NormalSlides","vendors~ShareSlides":"vendors~ShareSlides","vendors~CallupHead":"vendors~CallupHead","vendors~Comment~ShareComment":"vendors~Comment~ShareComment","vendors~Comment":"vendors~Comment","vendors~ShareComment":"vendors~ShareComment","vendors~DataBox":"vendors~DataBox","vendors~Hongbao":"vendors~Hongbao","vendors~NormalTabs":"vendors~NormalTabs","vendors~Player":"vendors~Player","vendors~QQShare":"vendors~QQShare","vendors~SlidesTabs":"vendors~SlidesTabs","vendors~Survey":"vendors~Survey","vendors~WXGuideLayer":"vendors~WXGuideLayer"}[chunkId]||chunkId) + "." + {"AccountOpening":"6be4804e","BackTopBottom":"82b09999","CallupVideoAppHead":"f06f7454","Caption":"6e2d8bb5","Copyright":"32e18abf","HomeFooter":"21e4345e","Img":"a4ff1254","MarkTabs":"56b83536","MoreTabs":"3eef2e7f","Nav":"24a96105","NormalCaption":"3c0d7eba","Offline":"df063ff6","Tip":"ec25e65f","ViewMoreLink":"856c3b51","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"fc55f77e","Atlas":"53c8aedf","FiveNavPic":"11f126d3","FourNavPic":"e6fbe65c","MdBanner":"4325872d","ThreeNavPic":"e45e590d","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg":"f709de56","vendors~BigImg~BigTopic~InformationFlow~TitleImg~TwoImg":"c44c2483","vendors~BigTopic~InformationFlow~TitleImg":"024ccd47","vendors~BigTopic~InformationFlow~SingleTitle":"74161fa2","vendors~BigImg~InformationFlow":"cee204ec","vendors~InformationFlow~SlideImg":"c1bf0597","vendors~BigTopic~InformationFlow":"71258c34","vendors~InformationFlow~TwoImg":"16a84222","vendors~InformationFlow":"bbe71a67","vendors~BigImage~NewsStream~NoImage~OneImage~Stick~ThreeImage~TwoImage":"6f5e0f75","Stick":"1a4c85e7","TwoImage":"eb5926eb","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"b393adee","NoImage":"c46c78c7","vendors~BigImage~NewsStream":"bccbcf18","BigImage":"a0eb9fe7","vendors~NewsStream~OneImage":"045ca3f2","OneImage":"4ed4cfbe","vendors~NewsStream~ThreeImage":"ba80ccd9","vendors~NewsStream":"56a63380","SingleTitle":"92bd0a25","SlideImg":"ce6c5d6f","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"0578d247","vendors~BottomSlides~UpgradeBottomSlides":"03c81692","vendors~UpgradeBottomSlides":"0f1a68df","vendors~IndexSlides":"db4e9edf","vendors~NormalSlides":"baf1d0d3","vendors~ShareSlides":"ae332d77","vendors~CallupHead":"cffec979","vendors~Comment~ShareComment":"90a3d2a0","vendors~Comment":"0bf28900","vendors~ShareComment":"08895185","vendors~DataBox":"fc93fc5f","vendors~Hongbao":"6bdb0472","vendors~NormalTabs":"b8a9a387","vendors~Player":"100954c4","vendors~QQShare":"be27e510","vendors~SlidesTabs":"4a7ef86e","vendors~Survey":"1bdf5868","vendors~WXGuideLayer":"34eb40da"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x0.ifengimg.com/fe/lark/lark_comp/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["./views/mobile/USAElection2020/app.jsx","vendors~USAElection2020"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
